import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { DetailsIdentifier } from 'components/DataDisplay';
import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import {
  KnowledgeBaseLink,
  KnowledgeBaseLinks,
} from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseLinks';
import { LearnMoreInlineLink } from 'components/DataDisplay/KnowledgeBase/BaseComponents/LearnMoreInlineLink';
import { renderKnowledgeBaseList } from 'components/DataDisplay/KnowledgeBase/utils';

export const LearnMoreAboutIssues: FC = () => {
  const links: KnowledgeBaseLink[] = [
    { label: 'Security Graphs', field: 'security_graphs' },
    { label: 'Ticketing', field: 'ticketing' },
    { label: 'Remediation', field: 'remediation' },
  ];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="issues"
      headerTitle="Issues"
      body={
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Description</Text>
            <Text>
              Issues are individual detections under{' '}
              <LearnMoreInlineLink label="findings" field="findings" value />{' '}
              which tied to specific resources for policy violations. They are
              automatically identified by Ariksa by combining static and runtime
              information for each resource. As a corollary, each individual
              resource can have several issues associated with it, when it
              violates more than one policy.
            </Text>
            <Text pt={2}>
              Each issue is also what you’d investigate using security graphs
              and{' '}
              <LearnMoreInlineLink
                label="remediate"
                field="remediation"
                value
              />
              . Each resource with a detected issue is automatically triaged for
              all applicable risk factors to generate a 360º view of risk
              factors. Our proactive triaging, eliminates manual but repetitive
              steps that increase overall response and remediation times.
            </Text>
          </Stack>
          <Stack>
            <Text fontWeight={600}>Example of Findings and Issues</Text>
            <Stack spacing={1}>
              <DetailsIdentifier
                label="Finding"
                value="A virtual machine allows ingress network access on port 23 (telnet)"
              />
              <DetailsIdentifier
                label="Issues"
                isInline={false}
                spacing={1}
                value={renderKnowledgeBaseList([
                  'Virtual machine 1 is Internet accessible and has a role with access to sensitive data',
                  'Virtual machine 2 has critical or high vulnerabilities and is Internet exposed',
                  'Virtual machine 3 is not Internet exposed, has role with access to sensitive data',
                ])}
              />
            </Stack>
          </Stack>
          <KnowledgeBaseLinks links={links} />
        </Stack>
      }
    />
  );
};
